function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "icon_operation");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\u5168\\u90E8\\u9875\\u9762",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\u4FE1\\u606F\\u6D41\\u8FD0\\u8425"
}, /*#__PURE__*/React.createElement("rect", {
  id: "icon_operation",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.72914237,8.18200469 C7.51514452,8.18200469 11.6924756,11.8762045 11.6924756,16.2656949 C11.6924756,16.6712404 11.3660274,17 10.9633332,17 C10.560639,17 10.2341908,16.6712404 10.2341908,16.2656949 C10.2341908,12.7328317 6.74887841,9.65061483 3.72914237,9.65061483 C3.32644816,9.65061483 3,9.32185525 3,8.91630976 C3,8.51076427 3.32644816,8.18200469 3.72914237,8.18200469 Z M3.72914237,3 C11.0428969,3 17,9.95247012 17,16.2656949 C17,16.6712404 16.6735518,17 16.2708576,17 C15.8681634,17 15.5417153,16.6712404 15.5417153,16.2656949 C15.5417153,10.7194109 10.1858253,4.46861014 3.72914237,4.46861014 C3.32644816,4.46861014 3,4.13985056 3,3.73430507 C3,3.32875958 3.32644816,3 3.72914237,3 Z M5.09277505,13.5184386 C5.83251665,13.5184386 6.43746099,14.1354804 6.45640772,14.9093858 C6.43746099,15.6497958 5.83251665,16.2668376 5.09277505,16.2668376 C4.35303345,16.2668376 3.74808911,15.6497958 3.72914237,14.8758904 C3.74808911,14.1354804 4.35303345,13.5184386 5.09277505,13.5184386 Z",
  id: "\\u5F62\\u72B6\\u7ED3\\u5408",
  stroke: "#666666",
  strokeWidth: 0.1,
  fill: "#666666",
  fillRule: "nonzero"
})));

var SvgIconOperation = function SvgIconOperation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconOperation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_operation.d77568de.svg";
export { ForwardRef as ReactComponent };